import Flag from "app/components/Flag/Flag";
import { IconCheck } from "app/components/Icon/Icon";
import { CountryHelper } from "app/helpers/countryHelper";
import type { CompetitionType } from "app/types/competitionType";
import { connect } from "react-redux";
import "./Bookmarks.scss";
type Props = {
  competitionList: CompetitionType[];
  setBookmarks: (...args: Array<any>) => any;
};

const Bookmarks: React.FC<Props> = props => {
  return (
    <div className="bookmarks">
      {props.competitionList.map((item, index) => (
        <div key={index} className="bookmark">
          <div className="bookmark__flag">
            <Flag
              code={CountryHelper.getCountryCode(item.countryName)}
              size={32}
            />
          </div>
          <div className="bookmark__title">{item.translatedName}</div>
          <div className="bookmark__icon-check">
            <IconCheck />
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  competitionList: state.competitionListModel.competitionList,
});

const mapDispatchToProps = (dispatch: any) => ({
  setBookmarks: () => {
    dispatch.bookmarkListModel.setBookmarkList();
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Bookmarks) as any;
